const schema = (taskType) => ({
  type: 'object',
  required: [],
  properties: {
    tariff: {
      type: 'object',
      title: 'tariff',
      properties: {
        tariff_id: {
          type: 'string',
        },
        task_type_id: {
          type: 'string',
          default: '1',
        },
      },
    },
    vehicle_id: {
      type: 'string',
      title: ['1', '14'].includes(taskType) ? 'vehicle' : 'bill',
    },
    loader_id: {
      type: 'string',
      title: 'loader',
    },
    tonnage: {
      type: 'string',
      title: 'tonnage',
    },
    // coefficient: {
    //   type: 'string',
    //   title: 'coefficient',
    // },
    bill_number: {
      type: 'string',
      title: 'bill_number',
    },
    description: {
      type: 'string',
      title: 'description',
    },
  },
});

export default schema;
